import { RefreshCw, X } from "lucide-react";
import { useVersionCheck } from "@/hooks/useVersionCheck";

/**
 * Компонент уведомления о доступном обновлении приложения.
 * Появляется когда пользователь возвращается на вкладку после деплоя.
 */
export function UpdateNotification() {
  const { hasUpdate, applyUpdate, dismissUpdate } = useVersionCheck();

  if (!hasUpdate) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 ipad:left-auto ipad:right-4 ipad:w-96 z-[100] animate-slideIn">
      <div className="bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden">
        {/* Прогресс-бар сверху */}
        <div className="h-1 bg-gradient-to-r from-sequence-primary to-sequence-light" />

        <div className="p-4">
          <div className="flex items-start gap-3">
            {/* Иконка */}
            <div className="flex-shrink-0 w-10 h-10 bg-sequence-primary/10 rounded-full flex items-center justify-center">
              <RefreshCw className="w-5 h-5 text-sequence-primary" />
            </div>

            {/* Контент */}
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-gray-900 text-sm">
                Доступно обновление
              </h3>
              <p className="text-xs text-gray-600 mt-0.5">
                Новая версия приложения готова к установке
              </p>

              {/* Кнопки */}
              <div className="flex items-center gap-2 mt-3">
                <button
                  onClick={applyUpdate}
                  className="flex-1 px-3 py-2 bg-sequence-primary hover:bg-sequence-dark text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center gap-1.5"
                >
                  <RefreshCw size={14} />
                  Обновить
                </button>
                <button
                  onClick={dismissUpdate}
                  className="px-3 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 text-sm font-medium rounded-lg transition-colors"
                >
                  Позже
                </button>
              </div>
            </div>

            {/* Кнопка закрытия */}
            <button
              onClick={dismissUpdate}
              className="flex-shrink-0 p-1 hover:bg-gray-100 rounded-lg transition-colors"
              aria-label="Закрыть"
            >
              <X size={16} className="text-gray-400" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
